import React from 'react';
import Modal from 'react-modal';

import modal from '../../definitions/Modal';

import Row from '../tag/Row';
import Span from '../tag/Span';
import OTButton from '../tag/OTButton';
import { FormattedMessage } from 'react-intl';
import OTButtonGroup from '../tag/OTButtonGroup';

const style = modal({ content: { width: '400px' } });

let { id: module_id } = module;

const MobileClientModal = (props) => {
  let { hideModal, isOpen } = props;

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={hideModal}
        style={style}
        contentLabel=""
      >
        <Row>
          <p>
            <FormattedMessage id={`${module_id}.desc`}></FormattedMessage>
          </p>
        </Row>
        <Row>
          <OTButtonGroup type={'big'} fullWidth collapseOnMobile>
            <OTButton color={'blue'} onClick={hideModal} message={'OK'} />
          </OTButtonGroup>
        </Row>
      </Modal>
    </>
  );
};

Modal.setAppElement('body');
export default MobileClientModal;
